import React, { useState } from 'react'
import atoms from '../../../atoms'
import { FiEdit } from 'react-icons/fi'
import { useNavigate } from 'react-router'
import { Link, useSearchParams } from 'react-router-dom'
import constant from '../../../../constants/constant'
const { Table, Button } = atoms

const Index = ({ rolesList, addRolePath,subAdminRole }: any) => {
    const navigate = useNavigate()

    const columns = [
        { name: 'Role', selector: (row: any) => row.role_name, sortable: true },
        { name: 'Action', selector: (row: any) => row.action, },
    ]
    return (
        <div>
            <div className="row">
                <div className="col-6">
                </div>
                <div className="col-6 text-end">
                    <Button name={"Add Role"}
                        className=''
                        onClick={() => navigate(addRolePath)}
                    />
                </div>
            </div>
            <div>
                <Table columns={columns}
                    data={rolesList?.data?.map((item: any) => {
                        return ({
                            ...item,
                            action: <Link
                                to={`/settings/role/edit/${item.id}?assignedTo=${subAdminRole?.value}`}>

                                <Button className="table-edit-button fs-14 fw-400">
                                    <div className='d-flex align-items-center'>
                                        <FiEdit />
                                        <span className='ms-2 mb-0'>Edit</span>
                                    </div>
                                </Button>
                            </Link>
                        })
                    })}
                />
            </div>
        </div>
    )
}

export default Index